import { cartStore } from "@features/auth/tess-cart.store"
import { getTNEWOrigin } from "@features/auth/tnew-browser-session"
import { Button } from "@features/ui/Button"
import { Money } from "@utils/money"
import { observer } from "mobx-react-lite"
import { useEffect } from "react"
import { CartCountdownTimer } from "../CartCountdownTimer"

export const CartPanel = observer(() => {
  const cart = cartStore
  const isLoading = cart.isPending

  useEffect(() => {
    cartStore.refresh()
  }, [])

  const data = cart.data

  if (!data) {
    const message = isLoading ? "Loading cart." : "Your cart is empty"

    return <div>{cart.lastError ? <span className="text-[red]">{cart.lastError}</span> : message}</div>
  }

  return (
    <div className="flex flex-col gap-4 px-shelf">
      <CartCountdownTimer />
      {cart.lastError && <div className="text-[red]">{cart.lastError}</div>}
      {data.itemCount > 0 ? (
        <div className="flex flex-col gap-4">
          <div className="flex flex-col border-t first:border-t-0 first:pt-0 pt-3">
            {data.products.map((product, index) => (
              <div key={`${product.name}-${index}`} className="border-b py-2 type-body-m">
                <div className="flex flex-col">
                  <div>{product.name}</div>
                  {product.productClass && <div className="text-fg-secondary">{product.productClass}</div>}
                </div>
                {product.lineItems.length > 0 && (
                  <div className="flex flex-col">
                    {product.lineItems.map((lineItem) => (
                      <div key={lineItem.id} className="flex">
                        <div className="flex-1">
                          {lineItem.seats
                            ? lineItem.seats
                                .map((seat) => [seat?.Section?.ShortDescription, seat?.Row, seat?.Number].join(" "))
                                .join(", ")
                            : "No seats"}
                        </div>
                        <div className="w-[4em]">{Money.formatDollars(lineItem.totalDue)}</div>
                        <button
                          onClick={() => {
                            cartStore.removeLineItem({
                              lineItemId: lineItem.id!,
                              performanceId: product.performanceId!,
                            })
                          }}
                        >
                          X
                        </button>
                      </div>
                    ))}
                    {/* {JSON.stringify(product)} */}
                    {/* {Money.formatDollars(product)} x {product.quantity} */}
                  </div>
                )}
              </div>
            ))}
          </div>
          <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 type-body-m">
            <dt className="text-fg-secondary">Items</dt>
            <dd>{data.itemCount}</dd>
            <dt className="text-fg-secondary">Subtotal</dt>
            <dd>{Money.formatDollars(data.subTotal)}</dd>
            <dt className="text-fg-secondary">Fees</dt>
            <dd>{Money.formatDollars(data.feesAmount)}</dd>
            <dt className="text-fg-secondary">Total</dt>
            <dd>{Money.formatDollars(data.amount || data.balanceToCharge)}</dd>
          </dl>
          <Button
            loading={isLoading}
            onClick={async () => {
              const link = (await getTNEWOrigin()) + "/cart/payment"
              window.location.href = link
            }}
          >
            Check Out
          </Button>
        </div>
      ) : (
        <div className="type-body-m">{isLoading ? "Loading cart." : "Cart empty."}</div>
      )}
    </div>
  )
})
